import { createFileRoute } from '@tanstack/react-router'
import { FullPrompt } from '#/components/ontology/full-prompt'
import { promptSearchSchema } from '#/components/ontology/search'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/ontology/prompt',
)({
  validateSearch: promptSearchSchema,
  component: PromptRoute,
})

function PromptRoute() {
  const { variant, highlight } = Route.useSearch()
  return <FullPrompt variantId={variant} highlight={highlight} />
}
